import { useEffect, useRef, useState } from "react";

type CountUpProps = {
  end: number;
  duration?: number;
  className?: string;
  /** formata o valor a cada frame; padrão: inteiro em pt-BR (1.500) */
  formatter?: (n: number) => string;
};

/** número que conta de 0 até `end` na primeira vez que entra no viewport */
const CountUp = ({ end, duration = 1400, className, formatter }: CountUpProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const started = useRef(false);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || started.current) return;
        started.current = true;
        obs.disconnect();
        const t0 = performance.now();
        const step = (t: number) => {
          const p = Math.min(1, (t - t0) / duration);
          const eased = 1 - Math.pow(1 - p, 3);
          setValue(end * eased);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.4 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [end, duration]);

  const fmt = formatter ?? ((n: number) => Math.round(n).toLocaleString("pt-BR"));

  return (
    <span ref={ref} className={className}>
      {fmt(value)}
    </span>
  );
};

export default CountUp;
